import React, { memo, useMemo, useState } from 'react';
import { ScommesseQuoteList, ScommesseQuoteListProps } from '../scommesseQuoteList';
import { esito, esitoTrKey } from 'components/scommesseTipo';
import { useInfoAggiuntivaIndex, useInfoAggiuntivaMeta, useInfoTipo } from 'features/sport/hooks';

import { ItemWithTranslation } from 'types/swagger';
import { KeyManagerSport } from 'features/sport';
import { ScommesseLeafItem } from '../cells';
import { ScommesseTableQuotaSelectContainer } from './scommessaTableQuotaSelectContainer';
import { SizeInfoAggiuntiva } from 'lib/api/sport/sportScommesseBySlugResponse';
import { isTruthy } from 'utility/functions';
import { useTranslation } from 'hooks/useLingUI';

export type ScommesseTableQuotaSelectProps = ItemWithTranslation<{
  //  header?: string;
  disabled?: boolean;
  selectedValue?: string;
  //  internalDropdownHeaders?: Array<string>;
}> &
  Omit<ScommesseQuoteListProps, 'setIsOpen'> & {
    size?: SizeInfoAggiuntiva | string;
    counter?: number;
    isEstesa?: boolean;
    showHeader?: boolean;
    className?: string;
    containerClassName?: string;
    bilanciataKey?: string;
    scommessaKey: string;
    hasBilanciata?: boolean;
    infoAggiuntivaKey?: string;
  };

export const ScommesseTableQuotaSelect = memo(function ScommesseTableQuotaSelect({
  size,
  // header,
  type,
  counter,
  disabled,
  isEstesa,
  className,
  containerClassName,
  // headerTrKey,
  showHeader,
  scommessaKey,
  bilanciataKey,
  // hasBilanciata = true,
  infoAggiuntivaKey,
  optionsKeys,
  selectedOptionKey,
  //  selectedValue,
  //  selectedValueTrKey,
  //   internalDropdownHeaders,
  //   internalDropdownHeadersTrKey,
  onOptionSelected,
}: ScommesseTableQuotaSelectProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const km = useMemo(() => new KeyManagerSport(scommessaKey), [scommessaKey]);
  const tipoScommessa = useInfoTipo(km.tipoScommessaId);
  const infoAggMeta = useInfoAggiuntivaMeta(scommessaKey);
  const infoAggIndex = useInfoAggiuntivaIndex(infoAggiuntivaKey);

  const headerList = useMemo(() => {
    if (type === ScommesseLeafItem.Quota) {
      return [t(esitoTrKey, esito)];
    }

    let index = counter ?? 0;
    const { headers, headersTrKey } = infoAggMeta ?? {};

    if (type === ScommesseLeafItem.MarcatoriInfoAgg) {
      const { headers, headersTrKey } = infoAggMeta ?? {};
      return [t(headersTrKey?.[headersTrKey.length - 1], headers?.[headers.length - 1])];
    }

    if (type === ScommesseLeafItem.InfoAggiuntiva) {
      return [t(headersTrKey?.[index], headers?.[index])];
    }

    const { esitoKeyList } = infoAggIndex ?? {};
    const list =
      (tipoScommessa?.numeroEsiti ?? 0) < 4 && isTruthy(esitoKeyList?.length)
        ? (tipoScommessa?.headers ?? []).map((k, idx) => t(tipoScommessa?.headersTrKey?.[idx], k))
        : [];
    list?.unshift(t(headersTrKey?.[index], headers?.[index]));

    return list;
  }, [
    t,
    type,
    counter,
    infoAggMeta,
    infoAggIndex,
    tipoScommessa?.headers,
    tipoScommessa?.headersTrKey,
    tipoScommessa?.numeroEsiti,
  ]);

  const objChild = useMemo(() => {
    if (isOpen) {
      return (
        <ScommesseQuoteList
          type={type}
          headerList={headerList}
          optionsKeys={optionsKeys ?? []}
          bilanciataKey={bilanciataKey}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          selectedOptionKey={selectedOptionKey}
          setIsOpen={setIsOpen}
          onOptionSelected={onOptionSelected}
        />
      );
    }

    return <React.Fragment key={infoAggiuntivaKey} />;
  }, [
    type,
    isOpen,
    headerList,
    optionsKeys,
    scommessaKey,
    bilanciataKey,
    selectedOptionKey,
    infoAggiuntivaKey,
    onOptionSelected,
  ]);

  return (
    <ScommesseTableQuotaSelectContainer
      type={type}
      size={size}
      isOpen={isOpen}
      itemKey={selectedOptionKey || infoAggiuntivaKey}
      disabled={disabled || optionsKeys?.length < 2}
      isEstesa={isEstesa}
      className={className}
      containerClassName={containerClassName}
      headerList={headerList}
      showHeader={showHeader}
      scommessaKey={scommessaKey}
      infoAggiuntivaKey={infoAggiuntivaKey}
      setIsOpen={setIsOpen}
    >
      {objChild}
    </ScommesseTableQuotaSelectContainer>
  );
});
